import React, { useContext, useState } from "react";
import { createPortal } from "react-dom";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { ARCHIVE_REFRESH_REQUESTED_ORIGINATOR, ViewMasterCampaignsContext } from "../index";
import { newArchiveCampaigns } from "../../../Flux/Actions/MasterCampaignActions";
import Modal from "@acadia-ui/modal";
import "../../../Views/Modals/modal.scss";
import { DataTableContext } from "../Tabs/Overview";

export default ({ rowData, type = "activation", ...rest }) => {
	const [open, setOpen] = useState(false);
	const { dataProvider, dataTableApi } = useContext(DataTableContext);
	const { setArchiveRefreshRequested } = useContext(ViewMasterCampaignsContext);

	const handleUnarchiveActivation = () => {
		if (rowData) {
			const archivedCampaigns = dataProvider?.data?.find(({ MasterCampaignID }) => MasterCampaignID == rowData?.ParentUniqueIDcode)?.ArchivedCampaigns;

			if (archivedCampaigns) {
				const archivedCampaignsAllPlatforms =
					Object?.values(archivedCampaigns)?.reduce((acc, curr) => {
						acc = [...acc, ...curr];
						return acc;
					}, []) || [];

				let postData;
				if (archivedCampaignsAllPlatforms?.length == 1) {
					postData = {
						ActionType: "unarchive",
						MasterCampaignID: [rowData?.ParentUniqueIDcode],
						CampaignID: []
					};
				} else {
					postData = {
						ActionType: "unarchive",
						MasterCampaignID: [],
						CampaignID: [rowData?.CampaignID]
					};
				}
				newArchiveCampaigns(postData).then(() => {
					dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
					setTimeout(() => dataProvider?.update?.(), 1);
				});
				setOpen(!open);

				setArchiveRefreshRequested(ARCHIVE_REFRESH_REQUESTED_ORIGINATOR.ARCHIVE_TAB);
			}
		}
	};

	const handleUnarchiveMaster = () => {
		if (rowData?.MasterCampaignID) {
			newArchiveCampaigns({
				ActionType: "unarchive",
				MasterCampaignID: [rowData?.MasterCampaignID],
				CampaignID: []
			}).then(() => {
				setTimeout(() => dataProvider?.update?.(), 1);
			});
			setOpen(!open);
			setArchiveRefreshRequested(ARCHIVE_REFRESH_REQUESTED_ORIGINATOR.ARCHIVE_TAB);
		}
	};

	const triggerOpenClose = (event) => {
		setOpen(!open);
	};

	return (
		<div className="unarchive-action-modal-container">
			<Button
				// This comment exists to prevent eslint from making this unreadable.
				id="unarchiveButton"
				className={"unarchive-button"}
				display={BUTTON_DISPLAY.TEXT}
				size={BUTTON_SIZE.MEDIUM}
				onClick={triggerOpenClose}
				data-tracking-id-alt="open-unarchive-campaign-modal"
				{...rest}
			>
				Restore
			</Button>
			{createPortal(
				<Modal
					id="restore__campaign"
					className={`master--campaign`}
					heading="Restore Campaign"
					description={"By clicking Restore, you will restore the selected campaigns. Do you want to continue?"}
					isOpen={open}
					onRequestClose={() => {
						if (open) {
							triggerOpenClose();
						}
					}}
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={triggerOpenClose} data-tracking-id-alt="cancel-unarchive-campaign">
									Cancel
								</Button>
								<Button
									display="primary"
									className="restore-button"
									onClick={type == "master" ? handleUnarchiveMaster : handleUnarchiveActivation}
									data-tracking-id-alt="confirm-unarchive-campaign"
									{...rest}
								>
									Restore
								</Button>
							</>
						)
					}}
				/>,
				document.body
			)}
		</div>
	);
};
